<template>
	<div>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer_mini = !drawer_mini"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <router-link
            :to="{ path: `/`}"
            style="text-decoration: none; color: black;"
        >
          <v-icon>mdi-finance</v-icon>
          <b> Finance Cabinet</b>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-chip
          outlined
          class="mx-2"
      >
          <span class="mx-1">
            <v-icon color="dark">
                mdi-currency-usd
            </v-icon>
            {{ currencyValues.usd_to_uah }}
          </span>
      </v-chip>

      <v-chip
          outlined
          class="mr-7"
      >
          <span class="mx-1">
            <v-icon color="dark">
                mdi-currency-eur
            </v-icon>
            {{ currencyValues.eur_to_uah }}
          </span>
      </v-chip>

      <app-bar-notification-component
          :classes="'mr-8'"
      ></app-bar-notification-component>

      <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="170"
          offset-y
          bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar v-bind="attrs" v-on="on" size="36px">
            <img v-if="userInfo.avatar" :src="userAvatarLink" height="25" width="25" alt="avatar">
            <v-icon v-else light>
              mdi-account-circle
            </v-icon>
          </v-avatar>
          <span v-bind="attrs" v-on="on" class="mr-2">
            <strong>
              <small>
                {{ userInfo.first_name }} {{ userInfo.last_name }}
              </small>
            </strong>
          </span>
        </template>

        <v-card>
          <v-list dense>
            <v-list-item @click.prevent="profileSettings">
              <v-list-item-action>
                  <v-icon>mdi-account-cog</v-icon>
              </v-list-item-action>
              <v-list-item-title class="text-left">
                <strong>
                  Profile settings
                </strong>
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click.prevent="logout">
              <v-list-item-action>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-action>
              <v-list-item-title class="text-left">
                <strong>
                  Logout
                </strong>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="drawer_mini"
        app
        color="#1e1e2d"
        width="256"
    >

      <v-list
          nav
          dense
          :dark="true"
          color="#1e1e2d"
          style="padding-top: 64px;"
      >
        <v-list-item-group
            v-model="group"
            active-class="deep-primary--text text--accent-4"
        >

          <router-link :to="{ name: 'Home'}" class="router-link">
            <v-list-item :class="getActiveLinkClass('Home')">
              <v-list-item-icon>
                <v-icon>mdi-chart-box-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-left">
                Dashboard
              </v-list-item-title>
            </v-list-item>
          </router-link>

          <v-divider></v-divider>

          <router-link :to="{ name: 'Finance'}" class="router-link">
            <v-list-item :class="getActiveLinkClass('Finance')">
              <v-list-item-icon>
                <v-icon>mdi-piggy-bank</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-left">
                Finances
              </v-list-item-title>
            </v-list-item>
          </router-link>

          <v-divider></v-divider>

          <router-link :to="{ name: 'Invoices'}" class="router-link">
            <v-list-item :class="getActiveLinkClass('Invoices')">
              <v-list-item-icon>
                <v-icon>mdi-list-box-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-left">
                Invoices
              </v-list-item-title>
            </v-list-item>
          </router-link>

          <v-divider></v-divider>

          <router-link :to="{ name: 'Contracts'}" class="router-link">
            <v-list-item :class="getActiveLinkClass('Contracts')">
              <v-list-item-icon>
                <v-icon>mdi-draw</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-left">
                Contracts
              </v-list-item-title>
            </v-list-item>
          </router-link>

          <v-divider></v-divider>

          <v-list-group
              :value="isOpenSubItemLinks(['EmailTemplates', 'Templates', 'Templates-Beta', 'Styles'])"
              prepend-icon="mdi-folder"
              color="while"
          >
            <template v-slot:activator >
              <v-list-item-title class="text-left">
                Templates
              </v-list-item-title>
            </template>

            <router-link v-if="!drawer_mini" :to="{ name: 'EmailTemplates'}" class="router-link">
              <v-list-item class="pl-3" :class="getActiveLinkClass('EmailTemplates')">
                <v-list-item-icon>
                  <v-icon class="pl-3" :small=true>
                    mdi-email-newsletter
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-left">
                  Email templates
                </v-list-item-title>
              </v-list-item>
            </router-link>

            <router-link v-if="!drawer_mini" :to="{ name: 'Templates'}" class="router-link">
              <v-list-item class="pl-3" :class="getActiveLinkClass('Templates')">
                <v-list-item-icon>
                  <v-icon class="pl-3" :small=true>
                    mdi-file-document-multiple-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-left">
                  Document templates
                </v-list-item-title>
              </v-list-item>
            </router-link>

            <router-link v-if="!drawer_mini" :to="{ name: 'Templates-Beta'}" class="router-link">
              <v-list-item class="pl-3" :class="getActiveLinkClass('Templates-Beta')">
                <v-list-item-icon>
                  <v-icon class="pl-3" :small=true>
                    mdi-file-document-multiple-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-left">
                  Document templates(BETA)
                </v-list-item-title>
              </v-list-item>
            </router-link>

            <router-link v-if="!drawer_mini" :to="{ name: 'Styles'}" class="router-link">
              <v-list-item class="pl-3" :class="getActiveLinkClass('Styles')">
                <v-list-item-icon>
                  <v-icon class="pl-3" :small=true>
                    mdi-palette-swatch-variant
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-left">
                  Document styles
                </v-list-item-title>
              </v-list-item>
            </router-link>
          </v-list-group>

          <v-divider></v-divider>

          <router-link :to="{ name: 'ProfileSettings'}" class="router-link">
            <v-list-item :class="getActiveLinkClass('ProfileSettings')">
              <v-list-item-icon>
                <v-icon>mdi-account-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-left">
                Settings
              </v-list-item-title>
            </v-list-item>
          </router-link>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

		<v-main>
			<v-breadcrumbs :items="breadcrumbsItems" style="padding: 24px 24px 12px 24px;">
				<template v-slot:item="{ item }">
					<v-breadcrumbs-item :href="item.href">
						{{ item.text }}
					</v-breadcrumbs-item>
				</template>
			</v-breadcrumbs>

			<v-container fluid class="pt-0" style="overflow-y: scroll; scrollbar-width: none;">
				<router-view/>
			</v-container>
		</v-main>

		<v-footer
				app
				fixed
				:inset="true"
				class="d-flex justify-center"
		>
			Developed by
			<a href="https://whylemur.com/" target="_blank" class="pl-2">
				WhyLemur Software Company
			</a>
		</v-footer>
	</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AppBarNotificationComponent from "@/components/thirdParty/navigation/AppBarNotificationComponent.vue";
import {getLocalStorageValue, setLocalStorageValue} from "@/tools/helpers";

export default {
	name: 'MainLayout',
	components: {AppBarNotificationComponent},
	computed: {
		...mapActions(['auth/logout']),
		...mapGetters({
			isAuthenticated: 'auth/isAuthenticated',
			breadcrumbsItems: 'breadcrumbsItems',
			currencyValues: 'currencyValues',
			userInfo: 'user/getShortInfo',
			userAvatarLink: 'user/getAvatarLink'
		})
	},
	data: () => ({
		drawer: true,
		drawer_mini: false,
		menu: false,
		group: null,
    styles: {
      active_link_class: 'deep-primary--text text--accent-4 v-list-item--active'
    }
	}),
	methods: {
		profileSettings() {
      if (this.$router.currentRoute.name !== 'ProfileSettings') {
        this.$router.push({ name: 'ProfileSettings', params: {} });
      }
		},
		logout() {
			this.$store.dispatch('auth/logout')
			window.location.replace('/login')
		},
    getActiveLinkClass(name, is_group=false) {
      if (!is_group) {
        return this.$router.currentRoute.name === name ? this.styles.active_link_class : ''
      }
      return ''
    },
    isOpenSubItemLinks(sub_items) {
      for (let index in sub_items) {
        if (this.$router.currentRoute.name === sub_items[index]) {
          return true
        }
      }
      return false
    },
	},
  mounted: function () {},
  created() {
		// load user info
		this.$store.dispatch('user/loadShortInfo')
		this.$store.dispatch('updateCurrencyValues')

    // load menu config
    this.drawer = getLocalStorageValue('menuDrawer', this.drawer)
    this.drawer_mini = getLocalStorageValue('menuDrawerMini', this.drawer_mini)
	},
	watch: {
    'drawer'(newValue) {
        setLocalStorageValue('menuDrawer', newValue)
    },
    'drawer_mini'(newValue) {
        setLocalStorageValue('menuDrawerMini', newValue)
    },
  }
}
</script>

<style scoped>
.router-link {
	color: white;
	text-decoration: none;
	font-size: 14px;
}

.text-left {
	text-align: left;
}
</style>
